// Hook
import {useState} from "react";
import useIsMounted from "Hooks/useIsMounted";

export default function useStorage(key, initialValue, storage = "sessionStorage") {
    const s = storage === "sessionStorage" ? window.sessionStorage : window.localStorage;
    const isMounted = useIsMounted();

    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        try {
            // Get from local storage by key
            const item = s.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        } catch (e) {
            //sendExceptionToSentry(e);
            // If error also return initialValue
            console.log(e);
            return initialValue;
        }
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value) => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            if (isMounted()) {
                setStoredValue(valueToStore);
            }
            // Save to local storage
            s.setItem(key, JSON.stringify(valueToStore));
        } catch (e) {
            //sendExceptionToSentry(e);
            // A more advanced implementation would handle the error case
            console.log(e);
        }
    };

    const deleteItem = () => {
        try {
            s.removeItem(key);
        } catch (e) {
            //sendExceptionToSentry(e);
            // A more advanced implementation would handle the error case
            console.log(e);
        }
    };

    return {storedValue, setValue, deleteItem};
}
